import { api } from '@/lib/api/client';
import type { DailySummary, DayBookReport, SubstitutionReport, SubstitutionReportType } from './types';

/**
 * GET /api/reports/daily-summary — always today, no date param sent. The
 * backend supports ?date= for a different day, but the legacy screen this
 * replaces never used it, so neither does this one; a date picker here
 * would be a feature nobody asked for, not a faithful migration.
 */
export function fetchDailySummary(): Promise<DailySummary> {
  return api.get('/reports/daily-summary');
}

/** GET /api/reports/day-book — the day-end close (ISS-09). See types.ts. */
export function fetchDayBook(from: string, to: string, department?: string | null): Promise<DayBookReport> {
  return api.get('/reports/day-book', { query: { from, to, department: department || undefined } });
}

/** GET /api/reports/pharmacy-substitutions — the drug-substitution report. See types.ts. */
export function fetchSubstitutionReport(type: SubstitutionReportType, from: string, to: string): Promise<SubstitutionReport> {
  return api.get('/reports/pharmacy-substitutions', { query: { type, from, to } });
}
